<template>
    <div>
        <b-card
            class="placeholder"
            no-body
        >
            <template #header>
                <div class="d-flex align-items-center">
                    {{ placeholder.placeholder_type }}
                    <div class="ml-auto">
                        <b-dropdown
                            size="sm"
                            variant="secondary"
                            dropleft
                        >
                            <template #button-content>
                                <font-awesome-icon :icon="['fad', 'cog']" />
                            </template>
                            <b-dropdown-item @click="deletePlaceholder">
                                <font-awesome-icon :icon="['fad', 'trash']" class="text-danger" fixed-width />
                                Delete
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                </div>
            </template>
        </b-card>
    </div>
</template>

<style lang="scss" scoped>
@import '@/assets/css/_colors';

.placeholder {
    .card-header {
        border-bottom: 0;
        border-radius: .25rem;
    }
}
</style>

<script>
import moment from 'moment'

export default {
    data: () => ({}),
    props: [
        'unit',
        'placeholder'
    ],
    components: {},
    methods: {
        async deletePlaceholder() {
            const result = await this.$swal({
                html: 'Are you sure you want to delete this placeholder?',
                showCancelButton: true,
                confirmButtonText: 'Delete Placeholder',
                cancelButtonText: 'Cancel',
                reverseButtons: true
            })

            if (!result.value) {
                return
            }

            try {
                await this.axios.post(
                    `/api/units/remove_item_from_page/${this.placeholder.unit_page_slot_id}`,
                    {is_moved: 0}
                )
                this.$emit('delete')
            } catch (e) {
                await this.$store.dispatch('pushError', {
                    data: {
                        message: `Failed to delete placeholder: ${e.message}`,
                    },
                    time: moment().toISOString(),
                })
            }
        }
    }
}
</script>
